import React from "react";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft, faCheck } from "@fortawesome/free-solid-svg-icons";

const Careers = () => {
  return (
    <div className="bg-white">
      {/* header */}
      <Header className="static" />

      <div className="px-6 lg:px-32 xl:px-52 2xl:px-80 py-24 sm:py-32 2xl:py-48 font-body">
        <h2 className="font-body text-lg font-semibold pb-2">Grow your career with us!</h2>
        <ul className="font-body text-justify">
          The goal of our organisation is to be the leading global chauffeur
          company worldwide, and we're well on our way to achieve our goal.
          We're passionate about growth — not just the organisation's, but our
          employees as well. We know that a company is only as strong as its
          team, so we work to foster a motivational, feedback-friendly work
          environment where every department works together toward the same goal
          and make it possible in achieving it. Our office culture encourages,
          and often necessitates, cooperation and communication between
          departments. We know that every employee has valuable ideas, and we
          want your unique perspective on how to make Drivado even better.
          <br />
          <br />
          <li className="font-body"><FontAwesomeIcon icon={faCheck} className="text-secondary" /> &nbsp;Customer Support</li>
          <li className="font-body"><FontAwesomeIcon icon={faCheck} className="text-secondary" /> &nbsp;Finance / Accountancy</li>
          <li className="font-body"><FontAwesomeIcon icon={faCheck} className="text-secondary" /> &nbsp;Business Development / Sales</li>
          <li className="font-body"><FontAwesomeIcon icon={faCheck} className="text-secondary" /> &nbsp;Website / Product Designing</li>
          <li className="font-body"><FontAwesomeIcon icon={faCheck} className="text-secondary" /> &nbsp;Human Resource Administration</li>
          <br />
          Please mail us your resume at&nbsp; 
          <a href="mailto:hr@drivado.com" alt="" className="font-semibold hover:text-slate-600">
            hr@drivado.com
          </a>&nbsp;mentioning the position you are applying for and your years of
          experience in the relevant field. We would get back to you ASAP.
          <br />
          <br />
          We don't mind if you are a fresher though, provided you can convince
          us with your confidence and skill!
        </ul>
      </div>

      {/* footer */}
      <Footer />
    </div>
  );
};

export default Careers;
